import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const FIRST_CTA_ID = 'first-cta';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const update = () => {
      const el = document.getElementById(FIRST_CTA_ID);
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-47" data-mp="2aujpaodh84kb">
      {visible && <motion.div initial={{
      y: '100%',
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: '100%',
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-950/95 px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-48" data-mp="2atgyshk2g44x">
          <div className="mx-auto flex max-w-xl items-center justify-center" data-id="element-49" data-mp="335ng3jmr951h">
            <div className="w-full animate-shake" data-id="element-50" data-mp="2pbmpxe9vcqcq">
              <CTAButton compact label="Yes! I want it — only $27" data-id="element-51" data-mp="2uazb7ul3dpd7" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
export { FIRST_CTA_ID };